import axiosClient from "api/axios_client.js";

// Calls used by more than one page under /swiftboard/email-management.
const apiEmailManagement = {
  // email-template list, campaign wizard (template step)
  getAllEmailTemplates: (payload) => axiosClient.post("/email-management/email-template/get-all", payload),
};

export default apiEmailManagement;
